import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import commonNetwork, { commonRootUrl, rootUrl } from "../../common/api/commonNetwork";
// import "../../styles/paymentform-full.css";
import "../../styles/paymentform.css";
import { Field, Form, Formik, useField } from "formik";
import FormObserver from "../components/FormElements/FormObserver";
import InputMask from "react-input-mask";
import { formatCurrency } from "../../common/helpers/currencyHelper";
import { useNavigate } from "react-router-dom";
import { CvcInfo } from "../components/Elements";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
import { AmountInput, FieldRequired, FooterAllBrands, FooterLogo, InstallmentHtmlTable, InstallmentList, KvkkModal, Loading, PaymentDescriptionInput, PaymentProviders } from "../components"


const initialState = {
  cardNumber: "",
  // month: "",
  expireDate: "",
  cvc: "",
  cardHolderName: "",
  amount: "",
  orderDesc: "",
  paymentDescriptionInputVisible: false,
  paymentDescriptionInputRequired: false,
  paymentDescriptionIninitalValue: "",
  isEditAmount: false,
  orderResource: 1,
  selectedInstallment: 1,
  paymentProviderSelect: false,
  isShowInstallmentTable: false,
  logoUrl: "https://tahsilat.elogo.com.tr/Uploads/firm_logos/elogo-logo.svg",
  payButtonTitle: "",
  firmKvkkText: "",
  customer: {
    nameSurname: "",
    code: "",
    taxCode: "",
    gsmNumber: "",
    email: "",
    ip: "",
    id: 0,
    taxOffice: ""
  },
  invoiceNumber: "",
  documentId: "",
  payTransId: "",
}

const paymentProviderInitialParams = {
  selectedBankId: 0,
  selectedModalId: 0,
  selectedBank: "",
  cardType: "",
  cardBrand: "",
  cardOwner: "",
  manufacturerCard: "false",
  maxAmountAlert: "",
  minAmountAlert: "",
  paymentProvider: 0,
  initialPaymentProvider: 0,
  isApplyComission: true,
}

const PaymentForm = () => {

  const queryParameters = new URLSearchParams(decodeURIComponent(window.location.search))

  const navigate = useNavigate();

  const isInitialRef = useRef(true);
  const [formValues, setFormValues] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [installmentLoading, setInstallmentLoading] = useState(false);
  const [postPaymentLoading, setPostPaymentLoading] = useState(false);
  const [installmentTableLoading, setInstallmentTableLoading] = useState(false);
  const [paymentProviders, setPaymentProviders] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentProviderParams, setPaymentProviderParams] = useState(paymentProviderInitialParams);
  const [tokenResult, setTokenResult] = useState({
    isError: false,
    errorMessage: ""
  });
  const [apiInfo, setApiInfo] = useState({
    apiKey: "",
    apiSecret: ""
  });
  const [cardBrandInformation, setCardBrandInformation] = useState({
    type: "",
    id: 0,
    image: "",
    name: "",
    visa_MC_AmEx: ""
  });
  const [installmentTableHtml, setInstallmentTableHtml] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenKvkkModal, setIsOpenKvkkModal] = useState(false);

  const [installmentList, setInstallmentList] = useState([]);

  const [installmentLimitError, setInstallmentLimitError] = useState("");
  const [fixedAmount, setFixedAmount] = useState(0);
  const [fieldError, setFieldError] = useState("");
  const isIframe = queryParameters.get("iframe")

  useEffect(() => {

    if (formValues.cardNumber?.length > 18) {
      selectInstallmentInformation();
    }

  }, [formValues.cardNumber, paymentProviderParams.isApplyComission]);

  useEffect(() => {
    if (paymentAmount != formValues.amount) {
      setPaymentAmount(formValues.amount)
    }
  }, [formValues.amount]);

  useEffect(() => {

    if (formValues.paymentProviderSelect) {
      selectPaymentProviders();
    }
  }, [apiInfo, formValues]);

  useEffect(() => {

    if (isInitialRef.current) {
      isInitialRef.current = false;
    } else {

      selectInstallmentInformation();
    }

  }, [paymentProviderParams.paymentProvider]);

  useLayoutEffect(() => {
    getPaymentInfoByToken();
  }, []);

  function getRequestParameters() {
    const token = queryParameters.get("token");
    return {
      token
    }

  }
  const { token } = getRequestParameters();

  const getPaymentInfoByToken = async () => {

    const method = `/paymentform/${token}`;
    const { data, errorMessage, isSuccess } = await commonNetwork.get(method, null, apiInfo);


    setIsLoading(false);
    if (isSuccess) {

      setApiInfo({
        apiKey: data.apiKey,
        apiSecret: data.apiSecret
      });
      setPaymentProviderParams({
        ...paymentProviderParams,
        initialPaymentProvider: data.paymentProvider,
        isApplyComission: data.isApplyComission != null ? data.isApplyComission : true
      });

      var amount = data.amount?.toString();
      console.log(amount);
      if (parseInt(data.amount) > 0) {

        var last2 = amount.slice(-2);
        var first = amount.substring(0, amount.length - 2);
        amount = first + "." + last2;
        console.log(amount);
      } else {
        amount = 0;
      }

      // const amount = getPaymentAmount(data.amount);

      setPaymentAmount(amount);
      setFormValues({
        ...formValues,
        customer: data.customer,
        amount: amount,
        paymentProviderSelect: data.paymentProviderSelect,
        logoUrl: (data.firmInformations.firmLogourl != null && data.firmInformations.firmLogourl != "") ? "https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/"+data.firmInformations.firmLogourl : (data.logoUrl != null && data.logoUrl != "") ? data.logoUrl : initialState.logoUrl,
        payButtonTitle: data.payButtonTitle,
        isShowInstallmentTable: data.isShowInstallmentTable,
        firmKvkkText: data.firmKvkkText,
        paymentDescriptionInputRequired: data.paymentDescriptionInputRequired,
        paymentDescriptionInputVisible: data.paymentDescriptionInputVisible,
        paymentDescriptionIninitalValue: data.paymentDescriptionIninitalValue,
        orderDesc: data.paymentDescriptionIninitalValue,
        isEditAmount: data.isEditAmount,
        invoiceNumber: data.invoiceNumber,
        documentId: data.documentId,
        payTransId: data.payTransId
      });
      setFixedAmount(data.amount);

    } else {
      setTokenResult({
        errorMessage: errorMessage,
        isError: true
      });
    }
  }

  const selectPaymentProviders = async () => {

    const method = `posintegration/${token}`;

    const { data, errorMessage, isSuccess } = await commonNetwork.get(method, null, apiInfo);

    if (isSuccess) {
      setPaymentProviders(data);
    }
  }

  const getBrandInformation = async () => {

    const params = {
      CardNumber: formValues.cardNumber.replaceAll(" ", ""),
    }
    var method = "/cardbrand";

    const { data, errorMessage, isSuccess } = await commonNetwork.get(method, params, apiInfo);

    if (isSuccess) {
      setCardBrandInformation(data);
    }

  }

  const selectInstallmentInformation = async () => {

    if (!(formValues.cardNumber?.length > 18)) {
      return;
    }
    setInstallmentLoading(true);
    getBrandInformation();

    let vpId = (formValues.paymentProviderSelect && paymentProviderParams.paymentProvider > 0) ?
      paymentProviderParams.paymentProvider : paymentProviderParams.initialPaymentProvider;

    const params = {
      CardNumber: formValues.cardNumber.replaceAll(" ", ""),
      Amount: (formValues.amount + "").replaceAll(".", "").replaceAll(",", ""),
      PaymentProviderId: vpId,
      IsApplyCommission: paymentProviderParams.isApplyComission,
      PaymentFormToken: token
    }
    var method = "/installments";

    const { data, errorMessage, isSuccess } = await commonNetwork.get(method, params, apiInfo);

    setInstallmentLoading(false);

    if (isSuccess) {

      if (data.minAmountAlert || data.maxAmountAlert) {
        setInstallmentList([]);
        setInstallmentLimitError(data.minAmountAlert || data.maxAmountAlert);
      } else {
        setInstallmentLimitError("");
        setInstallmentList(data.installmentList);
        setPaymentProviderParams({
          ...paymentProviderParams,
          paymentProvider: data.vpId,
          ...data
        });
        console.log(data.amount)
        setPaymentAmount(data.amount);
      }


    } else {
      setInstallmentList([]);
      toast.error(errorMessage);
    }
  }

  const getInstallmentHtmlTable = async () => {

    const params = {
      amount: (formValues.amount + "").replaceAll(".", "").replaceAll(",", "")
    }
    setInstallmentTableLoading(true);

    const { data, errorMessage, isSuccess } = await commonNetwork.get("/installments/html-table", params, apiInfo);

    setIsOpenModal(true);
    setInstallmentTableHtml(data);
    setInstallmentTableLoading(false);
  }

  const getPaymentParameters = () => {

    var splList = formValues.expireDate.split("/");
    var month = splList[0].trim() + "";
    if (month.length == 1) {
      month = "0" + month;
    }
    const { apiKey, apiSecret } = apiInfo;
    const headerAuth = btoa(apiKey + ":" + apiSecret);

    const params = {
      CardHolderName: formValues.cardHolderName,
      CardHash: formValues.cardNumber,
      ExpireMonth: parseInt(month),
      ExpireYear: parseInt(splList[1].trim()),
      CvvCode: formValues.cvc,
      Installment: formValues.selectedInstallment,
      OrderDesc: formValues.orderDesc,
      OrderResource: formValues.orderResource,
      Paymentprovider: paymentProviderParams.paymentProvider,
      ManufacturerCard: paymentProviderParams.manufacturerCard,
      amount: paymentAmount,
      firstAmount: (formValues.amount + "").replaceAll(".", "").replaceAll(",", "") + "",
      ApiInfo: headerAuth,
      Token: token
    }
    return params;
  }


  function submitPaymentForm() {
    setPostPaymentLoading(true);

    const params = getPaymentParameters();
    var form = document.createElement("form");
    var url = rootUrl;


    form.method = "POST";
    form.action = url + "/paymentform/payment-post";

    for (const property in params) {
      var element1 = document.createElement("input");
      // if (property == "ApiInfo") {
      //   element1.value = headerAuth;

      // } else {
      element1.value = params[property];
      // }
      element1.name = property;
      element1.type = "hidden";
      form.appendChild(element1);
    }



    document.body.appendChild(form);

    form.submit();
  }


  const getPaymentAmount = (payAmount) => {

    var amount = payAmount?.toString().replaceAll(".", "").replaceAll(",", "");
    var last2 = amount.slice(-2);
    var first = amount.substring(0, amount.length - 2);
    var amount = first + "." + last2;

    return {
      formatted: formatCurrency(amount),
      unformatted: amount
    }
  }




  const validate = (values) => {
    let errors = {};

    const cvc = values.cvc;
    const expire = values.expireDate;
    const cardNumber = values.cardNumber;
    const cardHolderName = values.cardHolderName;
    const orderDesc = values.orderDesc;
    const amount = (values.amount + "").replaceAll(".", "").replaceAll(",", "");

    if (fieldError != "") {
      errors.amount = fieldError;
    }

    if (cardHolderName.length == 0) {
      errors.cardHolderName = "Ad soyad alanı zorunludur";
    }
    if (orderDesc?.length == 0 && formValues.paymentDescriptionInputRequired) {
      errors.orderDesc = "Ödeme Açıklaması alanı zorunludur";
    }

    if (!(parseInt(amount) > 0) && formValues.isEditAmount) {
      errors.amount = "Ödeme Açıklaması alanı zorunludur";
    }
    if (cardNumber.length < 19) {
      errors.cardNumber = cardNumber.length == 0 ? "Kart numarası zorunludur" : "Kart numarası eksik tuşlanmıştır.";
    }
    if (cvc.toString().length < 3) {
      errors.cvc = cvc.length == 0 ? "Cvc alanı zorunludur" : "Cvc numarası eksik tuşlanmıştır.";
    }
    var expireList = expire.split("/");
    if (expireList.length > 0) {
      if (expireList.length == 1) {
        errors.expireDate = "Son kullanım tarihi eksik girilmiştir.";
      } else {
        var month = parseInt(expireList[0].trim());
        var year = parseInt(expireList[1].trim());
        if (month < 1 || month > 12) {
          errors.expireDate = "Son kullanım ayı hatalıdır.";
        } else {
          year = 2000 + year;
          var nowYear = new Date().getFullYear();
          if (year < nowYear) {
            errors.expireDate = "Son kullanım yılı hatalıdır.";
          }
        }
      }

    } else {
      errors.expireDate = "Son kullanım tarihi zorunludur";
    }

    return errors;
  };

  const getCardInformationAreaError = (errors, touched, values) => {

    var error = "";

    if (((values.cardNumber?.length > 0) && errors.cardNumber && touched.cardNumber)) {
      error = errors.cardNumber;
    } else if (((values.expireDate.length > 0) && errors.expireDate && touched.expireDate)) {
      error = errors.expireDate;
    } else if (((values.cvc.length > 0) && errors.cvc && touched.cvc)) {
      error = errors.cvc;
    }
    if (error) {
      return (
        <div className="flex-item-align-left" >
          <span className="FieldError Text Text-color--red Text-fontSize--13">
            <span aria-hidden="false" role="alert">{error}
            </span>
          </span>
        </div>
      );
    }
  }



  if (isLoading) {
    return (
      <Loading desc={"Yükleniyor..."} />
    );
  }
  if (tokenResult.isError) {
    return (
      <div className="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
        {tokenResult.errorMessage}
      </div>
    );
  }
  const paymentButtonDisabled = () => {
    return installmentLoading || installmentLimitError?.length > 0;
  }

  return (

    <div>
      {isIframe !== "true" ? (
        <div style={{
          height: 50,
          background: "#1B50DB"
        }} className="pl2 direction-row align-items-center justify-content-space-between">

          {isMobile ? (
            <button className="direction-row align-items-center px3 mb-1" onClick={() => navigate(-1)}>
              <img src="/webapitest/icons/back.png" width={20} height={20} />
              <span className="color-white pl2">
                Geri
              </span>
            </button>
          ) : null}
          <div className="direction-row align-items-center flex-3 ">
            <img src={"https://tahsilat.elogo.com.tr/assets/Logo/tahsiledin-txt.png"} width={110}></img>
          </div>
          <div className="flex-3">

          </div>
        </div>
      ) : null}

      <div className="App-Container is-noBackground flex-container justify-content-center">
        <div className="App App--singleItem">
          <div className="App-Payment is-noBackground">
            <div className="CheckoutPaymentForm">
              <div className="PaymentRequestOrHeader" style={{
                display: "inherit",
              }}>
                <div className="justify-content-center flex-container pb4 pt2">
                  <img src={formValues.logoUrl} width={130}></img>
                </div>

                <div className="ButtonAndDividerContainer opacity-1 display-block"   >
                  <div>

                  </div>
                  <div className="Divider">
                    <hr />
                    <p className="Divider-Text Text Text-color--gray400 Text-fontSize--16 Text-fontWeight--400">
                      Kredi Kartı İle Ödeme
                    </p>
                  </div>
                </div>
              </div>
              <div className="PaymentFormFixedHeightContainer flex-container direction-column"
                style={{
                  minHeight: 400
                }}>
                <Formik
                  initialValues={formValues}
                  enableReinitialize
                  validate={validate}
                  onSubmit={submitPaymentForm}
                >
                  {({
                    values,
                    setFieldValue,
                    errors,
                    touched,
                    getFieldProps
                  }) => (
                    <Form className="">
                      <FormObserver
                        watch={(val) => {
                          setFormValues(val);
                        }}
                      />
                      <div className="opacity-1">
                        {formValues.isEditAmount ?
                          <AmountInput errors={errors} onBlur={() => selectInstallmentInformation()}
                            setFieldValue={setFieldValue} touched={touched} value={formValues.amount} values={values} fixedAmount={fixedAmount} setFieldError={setFieldError}/>
                          : null}
                        <div className="App-Global-Fields flex-container spacing-16 direction-row wrap-wrap">
                          { formValues.invoiceNumber != "" && formValues.invoiceNumber != null ? (
                            <div className="flex-item width-12">
                            <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                              <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                                Fatura Numarası
                              </span>
                            </div>
                            <span className="FormFieldInput CheckoutInputContainer FormFieldGroup-Fieldset FormFieldGroup-container FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom InputContainer" >
                            <Field className={`CheckoutInput Input Input--empty`}
                                id="invoiceNumber"
                                name="invoiceNumber"
                                type="text"
                                inputMode="text"
                                value={values.invoiceNumber}
                                disabled={true}
                                style={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  opacity: 1,
                                  cursor: 'default',
                                  fontWeight: 'bold'
                                }}
                              />
                            </span>
                          </div>
                          ) : null}
                          { formValues.documentId != "" && formValues.documentId != null ? (
                            <div className="flex-item width-12">
                            <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                              <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                                Fiş Numarası
                              </span>
                            </div>
                            <span className="FormFieldInput CheckoutInputContainer FormFieldGroup-Fieldset FormFieldGroup-container FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom InputContainer" >
                            <Field className={`CheckoutInput Input Input--empty`}
                                id="documentId"
                                name="documentId"
                                type="text"
                                inputMode="text"
                                value={values.documentId}
                                disabled={true}
                                style={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  opacity: 1,
                                  cursor: 'default',
                                  fontWeight: 'bold'
                                }}
                              />
                            </span>
                          </div>
                          ) : null}
                          <div className="flex-item width-12">
                            <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                              <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                                Kart Üzerindeki İsim
                              </span>
                              {errors.cardHolderName && touched.cardHolderName ? <FieldRequired /> : null}
                            </div>
                            <span className="FormFieldInput CheckoutInputContainer FormFieldGroup-Fieldset FormFieldGroup-container FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom InputContainer" >
                              <Field className={`CheckoutInput Input Input--empty ${errors.cardHolderName && touched.cardHolderName ? "CheckoutInput--invalid" : ""}`}
                                id="cardHolderName"
                                name="cardHolderName"
                                type="text"
                                inputMode="text"
                                value={values.cardHolderName}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="PaymentForm-paymentMethodForm flex-container spacing-16 direction-column wrap-wrap">
                          <div className="flex-item width-12">
                            <div className="FormFieldGroup">
                              <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                                <label htmlFor="cardNumber-fieldset">
                                  <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                                    Kart Bilgileri
                                  </span>
                                </label>
                                {((errors.cardNumber && touched.cardNumber) ||
                                  (errors.expireDate && touched.expireDate) ||
                                  (errors.cvc && touched.cvc)) ? <FieldRequired /> : null}
                              </div>
                              <fieldset className="FormFieldGroup-Fieldset" id="cardNumber-fieldset">
                                <div className="FormFieldGroup-container" id="cardNumber-fieldset-inner">
                                  <span className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop CheckoutInputContainer FormFieldInput InputContainer">
                                    <InputMask
                                      mask={"9999 9999 9999 9999"}
                                      maskChar={null}
                                      className={`CheckoutInput CheckoutInput--tabularnums Input Input--empty ${errors.cardNumber && touched.cardNumber ? "CheckoutInput--invalid" : ""}`}
                                      id="cardNumber"
                                      name="cardNumber"
                                      value={values.cardNumber}
                                      placeholder="**** **** **** ****"
                                      onChange={(val) => setFieldValue("cardNumber", val.target.value)}
                                    />
                                  </span>
                                  <div className="FormFieldInput-Icons opacity-1" >
                                    {cardBrandInformation.image ? (
                                      <div style={{
                                        transform: "none"
                                      }}>
                                        <span
                                          className="FormFieldInput-IconsIcon is-visible"><img
                                            src={commonRootUrl + cardBrandInformation.image}
                                            alt="MasterCard"
                                            className=""
                                            height={"20"}
                                            style={{
                                              height: 30
                                            }}
                                            loading="lazy"
                                            fetchpriority="low" /></span>
                                      </div>
                                    ) : null}
                                    {cardBrandInformation.visa_MC_AmEx == "Visa" ? (
                                      <div style={{
                                        transform: "none"
                                      }}>
                                        <span
                                          className="FormFieldInput-IconsIcon is-visible">
                                          <img
                                            src={"https://tahsilat.elogo.com.tr/bankIcons/visa.svg"}
                                            alt="Visa"
                                            className="BrandIcon"
                                            loading="lazy"
                                            fetchpriority="low" /></span>
                                      </div>
                                    ) : cardBrandInformation.visa_MC_AmEx == "MasterCard" ? (
                                      <div style={{
                                        transform: "none"
                                      }}>
                                        <span
                                          className="FormFieldInput-IconsIcon is-visible"><img
                                            src={"https://tahsilat.elogo.com.tr/bankIcons/mastercard.svg"}
                                            alt="MasterCard"
                                            className="BrandIcon"
                                            loading="lazy"
                                            fetchpriority="low" /></span>
                                      </div>
                                    ) : cardBrandInformation.visa_MC_AmEx == "TROY" ? (
                                      <div style={{
                                        transform: "none"
                                      }}>
                                        <span
                                          className="FormFieldInput-IconsIcon is-visible"><img
                                            src={"https://tahsilat.elogo.com.tr/images/troy-yeni.png"}
                                            alt="TROY"
                                            className="BrandIcon"
                                            loading="lazy"
                                            fetchpriority="low" /></span>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="InputContainer CheckoutInputContainer FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childLeft FormFieldGroup-childBottom FormFieldInput">
                                    <InputMask
                                      className={`CheckoutInput CheckoutInput--tabularnums Input Input--empty ${errors.expireDate && touched.expireDate ? "CheckoutInput--invalid" : ""}`}
                                      mask={"99 / 99"}
                                      maskChar={null}
                                      id="expireDate"
                                      name="expireDate"
                                      value={values.expireDate}
                                      placeholder="AA / YY"
                                      aria-label="Son kullanma tarihi"
                                      type="text"
                                      inputMode="numeric"
                                      onChange={(val) => setFieldValue("expireDate", val.target.value)}
                                    />
                                  </div>
                                  <div className="FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childRight FormFieldGroup-childBottom FormFieldInput has-icon padding-right-32">
                                    <div className="CheckoutInputContainer InputContainer">
                                      <InputMask
                                        mask={"999"}
                                        maskChar={null}
                                        className={`CheckoutInput CheckoutInput--tabularnums Input Input--empty ${errors.cvc && touched.cvc ? "CheckoutInput--invalid" : ""}`}
                                        id="cvc"
                                        name="cvc"
                                        value={values.cvc}
                                        placeholder="CVC"
                                        aria-label="CVC"
                                        type="text"
                                        inputMode="numeric"
                                        onChange={(val) => setFieldValue("cvc", val.target.value)}
                                      />
                                    </div>
                                    <div className="FormFieldInput-Icon is-loaded" data-testid="FormFieldInput-Icon">
                                      <CvcInfo />
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                              {getCardInformationAreaError(errors, touched, values)}
                            </div>
                          </div>

                          {formValues.paymentDescriptionInputVisible ?
                            <PaymentDescriptionInput errors={errors} touched={touched} values={values} /> : null}
                          {formValues.isShowInstallmentTable && !(paymentProviderParams.initialPaymentProvider > 0) ? (
                            <div className="installment-button" onClick={getInstallmentHtmlTable}>
                              <div className="installment-button-ContentWrapper">
                                <div className="installment-button-Label">
                                  <div className="installment-button-LeadText">
                                    Tüm Taksit Seçeneklerini Göster
                                  </div>
                                </div>
                              </div>
                              {installmentTableLoading ? (
                                <div className="h-[24px] flex items-center">
                                  <span className="dots-flow-sm mt-1"></span>
                                </div>
                              ) : (
                                <img width="24" height="24" src="https://tahsilat.elogo.com.tr/apipayment/icons/arrow_right.svg" alt="" />
                              )}
                            </div>
                          ) : null}

                          {formValues.paymentProviderSelect ?
                            <PaymentProviders paymentProviders={paymentProviders}
                              selectedPaymentProvider={paymentProviderParams.paymentProvider}
                              disabled={installmentLoading}
                              setSelected={(val) => {
                                setPaymentProviderParams({
                                  ...paymentProviderParams,
                                  paymentProvider: val
                                });
                              }}
                            /> : null}
                          <div className="SignUpForm-signUpFormContainer SignUpForm-signUpContainer--noCheckbox flex-item width-12">
                            <div style={{
                              opacity: 1,
                              height: "auto",
                              pointerEvents: "auto",
                              display: "block"
                            }}>
                              <div>
                                {installmentLimitError?.length > 0 ? (
                                  <div className="danger-alert" role="alert">
                                    {installmentLimitError}
                                  </div>
                                ) : (
                                  <div className="SignUpForm SignUpForm--expanded">
                                    <div className="SignUpForm-headerContainer">
                                      <div className="SignUpForm-header width-12" >
                                        <span className="SignUpForm-headerText Text Text-color--default">
                                          <div className="SignUpForm-labelHeader opacity-1 pb-1 Text-fontSize--17" >
                                            Taksit Seçenekleri
                                          </div>
                                          {installmentList.length == 0 ? (
                                            <div className="SignUpForm-subLabel">
                                              Taksit seçeneklerini görmek için kart bilgilerini doldurunuz.
                                            </div>
                                          ) :
                                            <InstallmentList
                                              installmentList={installmentList}
                                              selectedInstallment={formValues.selectedInstallment}
                                              setSelected={(item) => {
                                                setFormValues({
                                                  ...formValues,
                                                  selectedInstallment: item.month
                                                });
                                                setPaymentAmount(formatCurrency(item.totalAmount));
                                              }}
                                            ></InstallmentList>
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="PaymentForm-confirmPaymentContainer mt4 flex-item width-grow">
                        <div className="flex-item width-12"></div>
                        <div className="flex-item width-12 pb2">
                          <button className="SubmitButton SubmitButton--incomplete btn-primary" type="submit"
                            style={{
                              backgroundColor: "#1B50DB",
                              color: "rgb(255, 255, 255)"
                            }}
                            disabled={paymentButtonDisabled() || postPaymentLoading}
                            loading={postPaymentLoading}
                          >
                            <div className="SubmitButton-TextContainer">
                              <span className="SubmitButton-Text SubmitButton-Text--current Text Text-color--default Text-fontWeight--500 Text--truncate"
                                aria-hidden="false" style={{
                                  opacity: postPaymentLoading ? 0 : 1
                                }}   >
                                <span>
                                  {getPaymentAmount(paymentAmount).formatted} TL
                                </span> {formValues.payButtonTitle || "Öde"}
                              </span>
                              <span style={{
                                opacity: postPaymentLoading ? 1 : 0
                              }} className="SubmitButton-Text SubmitButton-Text--pre Text Text-color--default Text-fontWeight--500 Text--truncate" aria-hidden="true">
                                Gerçekleştiriliyor...
                              </span>
                            </div>
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <InstallmentHtmlTable installmentTableHtml={installmentTableHtml}
              isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal} />
            <footer className="App-Footer Footer mt4">
              <div className="">

                <span className="Text Text-color--gray400 Text-fontSize--14 Text-fontWeight--400 line-height-21">
                  Ödeme işlemine devam ederek  <a className="Link Link--primary"
                    href="#" onClick={() => setIsOpenKvkkModal(true)} rel="noopener">
                    KVKK Aydınlatma Metni'ni </a>okuduğumu ve anladığımı kabul ediyorum.

                </span>
              </div>
            </footer>
            <KvkkModal firmKvkkText={formValues.firmKvkkText} isOpenKvkkModal={isOpenKvkkModal}
              setIsOpenKvkkModal={setIsOpenKvkkModal} />
            <FooterAllBrands apiInfo={apiInfo} />
            <FooterLogo />
          </div>
        </div>
      </div>
    </div>
  );
}
export default PaymentForm;


String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};